import OFooterCopyright from "./organisms/o-footer-copyright"
import OFooterContact from "./organisms/o-footer-contact"
import OFooterPartners from "./organisms/o-footer-partners"

export default {
  footer_copyright: OFooterCopyright,
  footer_contact: OFooterContact,
  footer_partners: OFooterPartners,
}
